// extracted by mini-css-extract-plugin
export default {"cls1":"VeloButton-StyledPrimaryButton_cls1__eyefg","cls2":"VeloButton-StyledPrimaryButton_cls2__qB379 VeloButton-StyledPrimaryButton_cls1__eyefg"};